import type { FaireProductEntity } from "../../entity_types/product";

export const p_93u9fqx97z: FaireProductEntity = {
  token: "p_93u9fqx97z",
  type: "product",
  name: "Women Colorful Button Knit Cardigan Coat",
  brandToken: "b_hrmradn4yd",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a6f84775760dcad88e8eeb40863881cc16296f8c321d159c015d8c548228b4be.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ec67109e285a5934226336849a7dbb4119b4f3edf81ffcccae55c216c9e37733.jpeg",
    "https://cdn.faire.com/fastly/90c6aac953d6cd28c2c222506ec1df45503640f371ab1523f579167b064b18dd.jpeg",
    "https://cdn.faire.com/fastly/a08deeebcf1e58ec67d4c9da28ec52dbe98c304dec56649b277662497ff79f8f.jpeg",
    "https://cdn.faire.com/fastly/f00f3a69a292bf0a1818896b25e6b09372fcc1c15349af770933be3bdd03d65f.jpeg",
    "https://cdn.faire.com/fastly/d77773a8eb98bc7cb50e2a706a74780c4991de5a2c11489c2f1d18746e16ab77.jpeg",
    "https://cdn.faire.com/fastly/710b0821a381d433efc4cb7d2a72fc86a384cb44a9dd3a03b8ef37046c8864a3.jpeg",
    "https://cdn.faire.com/fastly/1d9b8d75f92bb97f78f959069d909ea5c34c8cd9890020eb872d104b708afda1.jpeg",
    "https://cdn.faire.com/fastly/56097b26263bf65fcc10c042f77e21c8c6592974fff050c1cbdb317966aa5871.jpeg",
  ],
  priceDollars: 27.56,
  description:
    "Women Colorful Button Knit Cardigan Coat \nColorways: Off-White, Light Gray, Red, Charcoal Gray, Navy\nPrimary Material: Polyester\nFabric Weight: 400 GSM\nSIZE\tRECOMMENDED WEIGHT\nS\t (approx. 40-45 kg / 88-99 lbs)\nM\t(approx. 45-52.5 kg / 99-116 lbs)\nL\t1(approx. 52.5-57.5 kg / 116-127 lbs)\nXL\t1(approx. 57.5-65 kg / 127-143 lbs)",
  tags: [],
  msrpDollars: 55.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:59.895Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
